import React, { forwardRef } from "react";

import { Button } from "@chakra-ui/react";
import { Icon } from "@familyzone/component-library";
import { colours } from "utils/themeUtils";

interface Props {
	icon: string;
	label: string;
	disabled?: boolean;
	handleClick?: () => void;
	altText?: string;
	iconOnRightSide?: boolean;
	iconColor?: string;
	danger?: boolean;
	testId?: string;
}

export const ActionButton = forwardRef<HTMLButtonElement, Props>((props, ref) => {
	const { icon, label, disabled, altText, iconOnRightSide, danger, testId } = props;

	const iconColor = props.iconColor || (danger ? " #B11325" : "#6B778C");
	const textColor = danger ? "#B11325" : colours.navy[800];
	const backgroundColor = danger ? "#FFDBDF" : "white";
	const hoverBackgroundColor = danger ? "#fabec5" : "#F3F5F9";
	const borderColor = danger ? "#B1132522" : "#cdcdcd";
	return (
		<Button
			ref={ref}
			columnGap={8}
			title={altText}
			onClick={props.handleClick}
			borderRadius={"4px"}
			height={"32px"}
			padding={"10px 12px 10px 12px"}
			alignItems={"center"}
			border={`1px solid ${borderColor}`}
			background={backgroundColor}
			cursor={"pointer"}
			fontWeight={"medium"}
			color={textColor}
			_hover={{
				background: hoverBackgroundColor,
			}}
			transition={"ease-in-out"}
			transitionDuration={"0.2s"}
			isDisabled={disabled}
			data-testid={testId}
		>
			{!iconOnRightSide && <Icon icon={icon} variant="solid" color={iconColor} boxSize={4} />}
			{label}
			{iconOnRightSide && <Icon icon={icon} variant="solid" color={iconColor} boxSize={4} />}
		</Button>
	);
});
